import { IconProps } from "./Icon.model";

export function CheckmarkCircle01Icon({ size = 16, fill = "currentColor" }: IconProps) {
  const fillColor =
    fill === "currentColor" ? "currentColor" : `var(--${fill}-a8)`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0.833008C11.958 0.833008 15.167 4.04196 15.167 8C15.167 11.958 11.958 15.167 8 15.167C4.04196 15.167 0.833008 11.958 0.833008 8C0.833008 4.04196 4.04196 0.833008 8 0.833008ZM11.252 5.34668C11.0753 5.0237 10.6697 4.90538 10.3467 5.08203C9.12773 5.74874 8.12013 7.03546 7.44238 8.07324C7.19203 8.45659 6.97782 8.81947 6.80664 9.12695C6.64698 8.97204 6.48812 8.83839 6.34668 8.72656C6.16166 8.58028 5.99547 8.46432 5.87402 8.38477L5.66406 8.25391C5.34423 8.0715 4.93631 8.1831 4.75391 8.50293C4.57157 8.82263 4.68339 9.2296 5.00293 9.41211L5.14355 9.5C5.23873 9.56236 5.37147 9.6554 5.51953 9.77246C5.82457 10.0136 6.15419 10.3295 6.36133 10.6758C6.48839 10.8881 6.72265 11.0125 6.96973 10.999C7.21694 10.9854 7.43704 10.8355 7.54004 10.6104L7.60547 10.4736C7.6506 10.3813 7.71771 10.2462 7.80566 10.0801C7.982 9.74695 8.23902 9.29111 8.55859 8.80176C9.21402 7.79821 10.0724 6.75193 10.9863 6.25195C11.3094 6.07529 11.4286 5.66972 11.252 5.34668Z"
        fill={fillColor}
      />
    </svg>
  );
}
